@if (appearance === 'outlined') {
  <span class="material-symbols-outlined {{classes}}" [style]="styles" [style.font-variation-settings]="'\'FILL\' 0, \'wght\' ' + fontWeight + ', \'GRAD\' 0, \'opsz\' 48'">{{icon}}</span>
}
@if (appearance === 'filled') {
  <span class="material-symbols-outlined {{classes}}" [style]="styles" [style.font-variation-settings]="'\'FILL\' 1, \'wght\' ' + fontWeight + ', \'GRAD\' 0, \'opsz\' 48'">{{icon}}</span>
}